import React, { useState } from 'react';
import { Button, Menu, MenuItem, Typography, Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { getFlagEmoji } from '../utils/helpers';

const defaultLangList = [
    { id: 'en', label: 'EN', name: 'English' },
];

export const LanguageSelector = ({ langList, effectiveLang, onSwitchLang }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const languages = (langList || defaultLangList).map(lang => ({
        ...lang,
        label: lang.id.toUpperCase(),
        flag: getFlagEmoji(lang.id)
    }));

    const selectedLanguage = languages.find(l => l.id === effectiveLang) || languages[0];
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectLanguage = (language) => {
        if (onSwitchLang) onSwitchLang(language.id);
        handleClose();
    };

    return (
        <div>
            <Button
                id="language-button"
                aria-controls={open ? 'language-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant="outlined"
                sx={{
                    textTransform: 'none',
                    color: 'text.primary',
                    backgroundColor: '#EAF4FF',
                    px: 1.5,
                    py: 0,
                    borderRadius: 1,
                    border: '1px solid lightgray'
                }}
                endIcon={<KeyboardArrowDownIcon />}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <span role="img" aria-label={`${selectedLanguage.name} flag`} style={{ marginRight: '8px', fontSize: '1.4em' }}>
                        {selectedLanguage.flag}
                    </span>
                    <Typography color="primary">{selectedLanguage.label}</Typography>
                </Box>
            </Button>
            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'language-button',
                }}
            >
                {languages.map((language) => (
                    <MenuItem
                        key={language.id}
                        selected={language.id === selectedLanguage.id}
                        onClick={() => handleSelectLanguage(language)}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <span role="img" aria-label={`${language.name} flag`} style={{ marginRight: '8px', fontSize: '1.4em' }}>
                                {language.flag}
                            </span>
                            {language.label}
                        </Box>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}

export default LanguageSelector; 